export default "__VITE_ASSET__bd20393f__"